import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Form,
  FormInstance,
  message,
  Modal,
  Radio,
  Row,
  Space,
  Spin,
  Upload,
} from "antd";
import Text from "../../../components/Text/Text";
import Input from "../../../components/Input/Input";
import DatePicker, { TimePicker } from "../../../components/DatePicker/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import styled from "styled-components";
import ReactQuill, { Quill } from "react-quill";
import { color } from "../../../resource";
import { DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import { FlexCol, FlexRow } from "../../../components/Container/Container";
import ImgCrop from "../../../components/ImgCrop/ImgCrop";
import { ImageWithDeleteButton } from "../../../components/Image/Image";
import { getBase64, normFile } from "../../../utility/uploadHelper";
import { RcFile } from "antd/es/upload";
import { CustomFormItem, TextAreaStyle, UploadArea, UploadBox } from "../StyleCSS";
import { mapStatusEdit } from "../../../definitions/achievementStatus";
interface QuillContainerProps {
  disabled?: boolean;
}
const QuillContainer = styled.div<QuillContainerProps>`
  .ql-container {
    ${({ disabled }) =>
      disabled &&
      `
      background-color: ${color.background1};
      color: #999;
      border-radius: 8px;
      cursor: not-allowed;
      pointer-events: none; /* block interaction */
    `}
  }
  .ql-toolbar.ql-snow {
    border-radius: 4px 4px 0 0 !important;
  }
  .ql-container.ql-snow {
    border-radius: 0 0 4px 4px !important;
  }
  .ql-editor {
    max-height: 100vh;
    overflow: auto;
  }
`;
const MemoArea = styled.div`
  width: 100%;
  background: ${color.background1};
  border: 1px solid ${color.background2};
  border-radius: 8px;

  display: flex;
  align-items: center;
  padding: 16px;
`;
const MemoAreaItem = styled.div`
  padding: 0px 8px;
  display: flex;
  align-items: center;
`;
const UploadIcon = (
  <>
    <svg width='65' height='65' viewBox='0 0 65 65' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle opacity='0.36' cx='32.3335' cy='32.0176' r='32' fill='#E5EAEE' />
      <path
        d='M41.6667 29.3512C41.313 29.3512 40.9739 29.4917 40.7239 29.7418C40.4738 29.9918 40.3333 30.3309 40.3333 30.6846V35.1912L38.36 33.2179C37.6632 32.5266 36.7215 32.1387 35.74 32.1387C34.7585 32.1387 33.8168 32.5266 33.12 33.2179L32.1867 34.1646L28.88 30.8446C28.1832 30.1533 27.2415 29.7654 26.26 29.7654C25.2785 29.7654 24.3368 30.1533 23.64 30.8446L21.6667 32.8312V25.3512C21.6667 24.9976 21.8071 24.6585 22.0572 24.4084C22.3072 24.1584 22.6464 24.0179 23 24.0179H33.6667C34.0203 24.0179 34.3594 23.8774 34.6095 23.6274C34.8595 23.3773 35 23.0382 35 22.6846C35 22.3309 34.8595 21.9918 34.6095 21.7418C34.3594 21.4917 34.0203 21.3512 33.6667 21.3512H23C21.9391 21.3512 20.9217 21.7727 20.1716 22.5228C19.4214 23.273 19 24.2904 19 25.3512V41.6446C19.0035 42.6266 19.3952 43.5673 20.0895 44.2617C20.7839 44.9561 21.7247 45.3477 22.7067 45.3512H39.2933C39.6546 45.3484 40.0137 45.2945 40.36 45.1912V45.1912C41.1299 44.9753 41.8077 44.5127 42.2894 43.8744C42.7711 43.2362 43.0301 42.4575 43.0267 41.6579V30.6846C43.0267 30.5072 42.9914 30.3316 42.9227 30.1681C42.854 30.0046 42.7534 29.8564 42.6268 29.7322C42.5001 29.608 42.35 29.5104 42.1851 29.445C42.0202 29.3796 41.844 29.3477 41.6667 29.3512ZM23 42.6846C22.6464 42.6846 22.3072 42.5441 22.0572 42.294C21.8071 42.044 21.6667 41.7049 21.6667 41.3512V36.5912L25.52 32.7379C25.7149 32.5441 25.9785 32.4353 26.2533 32.4353C26.5282 32.4353 26.7918 32.5441 26.9867 32.7379L36.9467 42.6846H23ZM40.3333 41.3512C40.3248 41.6094 40.2414 41.8596 40.0933 42.0712L34.0667 36.0179L35.0133 35.0846C35.1089 34.987 35.223 34.9095 35.3489 34.8566C35.4749 34.8037 35.6101 34.7764 35.7467 34.7764C35.8833 34.7764 36.0185 34.8037 36.1444 34.8566C36.2703 34.9095 36.3844 34.987 36.48 35.0846L40.3333 38.9646V41.3512ZM44.3333 21.3512H43V20.0179C43 19.6643 42.8595 19.3251 42.6095 19.0751C42.3594 18.825 42.0203 18.6846 41.6667 18.6846C41.313 18.6846 40.9739 18.825 40.7239 19.0751C40.4738 19.3251 40.3333 19.6643 40.3333 20.0179V21.3512H39C38.6464 21.3512 38.3072 21.4917 38.0572 21.7418C37.8071 21.9918 37.6667 22.3309 37.6667 22.6846C37.6667 23.0382 37.8071 23.3773 38.0572 23.6274C38.3072 23.8774 38.6464 24.0179 39 24.0179H40.3333V25.3512C40.3333 25.7049 40.4738 26.044 40.7239 26.294C40.9739 26.5441 41.313 26.6846 41.6667 26.6846C42.0203 26.6846 42.3594 26.5441 42.6095 26.294C42.8595 26.044 43 25.7049 43 25.3512V24.0179H44.3333C44.687 24.0179 45.0261 23.8774 45.2761 23.6274C45.5262 23.3773 45.6667 23.0382 45.6667 22.6846C45.6667 22.3309 45.5262 21.9918 45.2761 21.7418C45.0261 21.4917 44.687 21.3512 44.3333 21.3512V21.3512Z'
        fill='#6B7995'
      />
    </svg>
  </>
);
const imgCropProps = {
  modalTitle: "ปรับขนาดรูปภาพ",
  modalOk: "ยืนยัน",
  modalCancel: "ยกเลิก",
};

interface Props {
  key: number;
  form1: FormInstance;
  setImgFile: any;
  setImgUrl: any;
  setFileMemo: any;
  setFileMemoUrl: any;
  imgUrl: any;
  fileMemoUrl: any;
  rule: any;
  status: string;
  isApproved: boolean;
}

function AchievementStep1({
  key,
  form1,
  setImgFile,
  setImgUrl,
  setFileMemo,
  setFileMemoUrl,
  imgUrl,
  fileMemoUrl,
  rule,
  status,
  isApproved,
}: Props) {
  const quillRef = useRef<any>(null);
  const [content, setContent] = useState(form1.getFieldValue("rule") || rule);
  const [loadingImg, setLoadingImg] = useState(false);
  const [imgFile1, setImgFile1] = useState<any>();
  const [imgUrl1, setImgUrl1] = useState<any>();
  const [fileMemo1, setFileMemo1] = useState<any>();
  const [fileMemoUrl1, setFileMemoUrl1] = useState<any>();
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const modules = {
    toolbar: {
      container: [
        ["bold", "italic", "link"],
        [{ size: ["small", false, "large", "huge"] }],
        [{ align: "" }, { align: "center" }, { align: "right" }],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
    },
  };

  useEffect(() => {
    setLoadingImg(true);
    setImgUrl1(imgUrl);
    setFileMemoUrl1(fileMemoUrl);
    setContent(form1.getFieldValue("rule") || rule);
    setLoadingImg(false);
    setIsEdit(mapStatusEdit(status, isApproved));
  }, [imgUrl, fileMemoUrl, rule, status, isApproved]);

  return (
    <div>
      <Form form={form1} layout='vertical'>
        <Row className='pb-3'>
          <Text level={5} fontWeight={700}>
            ข้อมูลทั่วไป
          </Text>
        </Row>
        <Row style={{ paddingBottom: "10px" }}>
          <FlexRow style={{ padding: "24px 0px 16px" }}>
            <FlexCol style={{ marginRight: 60 }}>
              <CustomFormItem
                name='image'
                valuePropName='file'
                rules={[
                  {
                    required: true,
                    message: "*กรุณาเพิ่มรูป",
                  },
                ]}
              >
                <ImgCrop aspect={800 / 890} {...imgCropProps}>
                  <UploadBox
                    listType='picture-card'
                    maxCount={1}
                    beforeUpload={(file) => {
                      const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
                      if (!isJpgOrPng) {
                        message.error("You can only upload JPG/PNG file!");
                        return true;
                      }
                      setImgFile(file);
                      setImgFile1(file);
                      getBase64(file as RcFile, (url) => {
                        form1.setFieldValue("image", url);
                        setImgUrl(url);
                        setImgUrl1(url);
                      });
                    }}
                    onChange={({ file }: any) => {
                      return "success";
                    }}
                    onRemove={() => {
                      form1.setFieldValue("image", "");
                      setImgFile(undefined);
                      setImgFile1(undefined);
                      setImgUrl(undefined);
                      setImgUrl1(undefined);
                    }}
                    showUploadList={false}
                    disabled={!!imgFile1 || !!imgUrl1}
                  >
                    {!imgFile1 && !imgUrl1 ? (
                      <UploadArea
                        style={{
                          width: "148px",
                          height: "148px",
                        }}
                      >
                        {UploadIcon}
                      </UploadArea>
                    ) : (
                      <Spin spinning={loadingImg}>
                        <ImageWithDeleteButton
                          width={"148px"}
                          height={"148px"}
                          src={imgUrl1}
                          handleDelete={() => {
                            form1.setFieldValue("image", "");
                            setImgFile(undefined);
                            setImgFile1(undefined);
                            setImgUrl(undefined);
                            setImgUrl1(undefined);
                          }}
                        />
                      </Spin>
                    )}
                  </UploadBox>
                </ImgCrop>
              </CustomFormItem>
            </FlexCol>
            <FlexCol>
              <Text level={6}>
                รูปภาพประกอบความสำเร็จ &nbsp;<span style={{ color: color.error }}>*</span>
              </Text>
              <Text level={6} color='Text3'>
                JPG, or PNG. Size of
                <br />
                800 x 890 px
              </Text>
            </FlexCol>
          </FlexRow>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name='achievementName'
              label='ชื่อความสำเร็จ'
              rules={[
                {
                  required: true,
                  message: "*โปรดระบุชื่อความสำเร็จ",
                },
              ]}
            >
              <Input placeholder='ระบุชื่อความสำเร็จ' autoComplete='off' />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name='achievementCode' label='รหัสความสำเร็จ (Auto)'>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name='refMemo'
              label='รหัส Ref. Memo'
              rules={[
                {
                  required: true,
                  message: "*โปรดระบุรหัส Ref. Memo",
                },
              ]}
            >
              <Input placeholder='ระบุรหัส Ref. Memo' autoComplete='off' disabled={isEdit} />
            </Form.Item>
          </Col>
        </Row>
        <Row style={{ paddingBottom: "10px" }}>
          <Col span={24}>
            <Form.Item name='description' label='คำอธิบาย'>
              <TextAreaStyle
                showCount={{
                  formatter: ({ count, maxLength }) => `${count}/${maxLength} ตัวอักษร`,
                }}
                maxLength={300}
                autoComplete='off'
                placeholder='คำอธิบายสั้นๆเกี่ยวกับความสำเร็จนี้'
              />
            </Form.Item>
          </Col>
        </Row>
        <Row align='middle' gutter={16}>
          <Col span={12}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name='startDate'
                  label='วันที่เริ่มต้น'
                  rules={[
                    {
                      required: true,
                      message: "*โปรดเลือกวันที่เริ่ม",
                    },
                  ]}
                >
                  <DatePicker
                    disabled={isEdit}
                    style={{ width: "100%" }}
                    disabledDate={(current: Dayjs) => {
                      const startDate = form1.getFieldValue("startDate");
                      const endDate = form1.getFieldValue("endDate");
                      const start = startDate ? dayjs(startDate) : null;
                      const end = endDate ? dayjs(endDate) : null;

                      if (!current) return false;
                      if (start && current.isAfter(end, "day")) {
                        return true;
                      }
                      if (end && current.isAfter(end, "day")) {
                        return true;
                      }
                      if (current.isBefore(dayjs().endOf("day"))) {
                        return true;
                      }
                      return false;
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name='startTime'
                  label='เวลาเริ่ม'
                  initialValue={dayjs("00:00", "HH:mm")}
                >
                  <TimePicker allowClear={false} disabled={isEdit} />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name='endDate'
                  label='วันที่สิ้นสุด'
                  rules={[
                    {
                      required: true,
                      message: "*โปรดเลือกวันที่สิ้นสุด",
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    disabledDate={(current: Dayjs) => {
                      const startDate = form1.getFieldValue("startDate");
                      return (
                        (current && current.isBefore(dayjs(startDate))) ||
                        current < dayjs().endOf("day")
                      );
                    }}
                    enablePast
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name='endTime'
                  label='เวลาสิ้นสุด'
                  initialValue={dayjs("23:59", "HH:mm")}
                >
                  <TimePicker
                    allowClear={false}
                    disabledTime={(now) => {
                      const startDate = form1.getFieldValue("startDate") as Dayjs;
                      const endDate = form1.getFieldValue("endDate") as Dayjs;
                      const startTime = form1.getFieldValue("startTime") as Dayjs;
                      const isSameDay = startDate && endDate && startDate?.isSame(endDate, "year");
                      if (!isSameDay) return {};

                      const hour = startTime.hour();
                      const minute = startTime.minute();
                      const hours: number[] = [];
                      const minutes: number[] = [];
                      for (let i = 0; i < hour; i++) {
                        hours.push(i);
                      }
                      for (let i = 0; i <= minute; i++) {
                        minutes.push(i);
                      }
                      return {
                        disabledHours: () => hours,
                        disabledMinutes: (selectedHour: number) =>
                          selectedHour === hour ? minutes : [],
                      };
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Form.Item
            name='conditionsToAchieve'
            label='เงื่อนไขความสำเร็จ'
            rules={[
              {
                required: true,
                message: "*โปรดเลือกเงื่อนไขความสำเร็จ",
              },
            ]}
          >
            <Radio.Group disabled={isEdit}>
              <Space>
                <Radio value={"THB"}>
                  <Text fontFamily='Sarabun' fontSize={14}>
                    ยอดซื้อสะสม (บาท)
                  </Text>
                </Radio>
                <Radio value={"QTY"}>
                  <Text fontFamily='Sarabun' fontSize={14}>
                    ยอดซื้อสะสม (จำนวน)
                  </Text>
                </Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
        </Row>
        <Row>
          <Form.Item
            name='receiveRewardType'
            label='เงื่อนไขการรับรางวัล'
            rules={[
              {
                required: true,
                message: "*โปรดเลือกเงื่อนไขการรับรางวัล",
              },
            ]}
          >
            <Radio.Group disabled={isEdit}>
              <Space>
                <Radio value={"STEP"}>
                  <Text fontFamily='Sarabun' fontSize={14}>
                    รับรางวัลแบบขั้นบันได (รางวัลสูงสุด)
                  </Text>
                </Radio>
                <Radio value={"ALL_LEVELS"} disabled>
                  <Text fontFamily='Sarabun' fontSize={14}>
                    รับรางวัลของทุกๆระดับ (ทุกรางวัลที่สำเร็จ)
                  </Text>
                </Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
        </Row>
        <Form.Item
          name='rule'
          label='กติกาและเงื่อนไข'
          rules={[
            {
              required: true,
              message: "*โปรดระบุกติกาและเงื่อนไข",
            },
          ]}
          required
        >
          <QuillContainer>
            <ReactQuill
              ref={quillRef}
              modules={modules}
              onChange={(c) => {
                setContent(c);
                form1.setFieldValue("rule", c);
              }}
              value={content}
            />
          </QuillContainer>
        </Form.Item>
      </Form>
      <Row align='middle'>
        <Text level={5} fontWeight={700}>
          ไฟล์เอกสารอ้างอิง
        </Text>
      </Row>
      <Row>
        <Col span={10}>
          <MemoArea>
            <MemoAreaItem style={{ width: 124 }}>
              <Form.Item
                noStyle
                name='memoFile'
                valuePropName='fileList'
                getValueFromEvent={normFile}
              >
                <Upload
                  beforeUpload={(file) => {
                    const isPDF = file.type === "application/pdf";
                    if (!isPDF) {
                      message.error(`อัปโหลดเฉพาะไฟล์ pdf เท่านั้น`);
                      return false;
                    }
                    return isPDF || Upload.LIST_IGNORE;
                  }}
                  customRequest={({ file, onSuccess }) => {
                    if (onSuccess) {
                      onSuccess(file);
                    }
                  }}
                  onChange={({ file }: any) => {
                    if (file.status === "uploading") {
                      setFileMemo1(file);
                      setFileMemo(file);
                      file.status = "done";
                    }
                    if (file.status === "done") {
                      setFileMemo1(file);
                      setFileMemo(file);
                    }
                    return "success";
                  }}
                  onRemove={() => {
                    setFileMemo(undefined);
                    setFileMemo1(undefined);
                  }}
                  maxCount={1}
                  showUploadList={false}
                  disabled={isEdit}
                >
                  <Button type='primary' icon={<UploadOutlined />}>
                    เลือกไฟล์
                  </Button>
                </Upload>
              </Form.Item>
            </MemoAreaItem>
            <MemoAreaItem style={{ width: "calc(100% - 156px)" }}>
              <svg
                width='24'
                height='31'
                viewBox='0 0 24 31'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M20.0596 0.0175781L24 3.84855V5.85091V27.5176C24 28.8983 22.8487 30.0176 21.4286 30.0176H2.57143C1.15127 30.0176 0 28.8983 0 27.5176V2.51758C0 1.13687 1.15127 0.0175781 2.57143 0.0175781H18H20.0596ZM18 1.18424H2.57143C1.85609 1.18424 1.26867 1.71671 1.2056 2.39622L1.2 2.51758V27.5176C1.2 28.213 1.74768 28.7842 2.4466 28.8455L2.57143 28.8509H21.4286C22.1439 28.8509 22.7313 28.3184 22.7944 27.6389L22.8 27.5176V5.85091H18V1.18424ZM22.8 4.68424L22.8 4.33174L19.5626 1.18424H19.2V4.68424H22.8Z'
                  fill='#464E5F'
                />
                <path d='M4 15.6846H5.83333V17.5179H4V15.6846Z' fill='#464E5F' />
                <path
                  d='M6.75 12.0176H8.98014C9.41286 12.0176 9.74294 12.0895 9.97039 12.2334C10.2034 12.372 10.3587 12.5718 10.4364 12.833C10.5196 13.0888 10.5612 13.4246 10.5612 13.8403C10.5612 14.24 10.5224 14.5704 10.4447 14.8315C10.367 15.0873 10.2117 15.2925 9.97871 15.4471C9.74571 15.5963 9.40731 15.6709 8.9635 15.6709H7.80682V17.5176H6.75V12.0176ZM8.614 14.7916C8.89138 14.7916 9.08832 14.7676 9.20482 14.7196C9.32687 14.6663 9.40454 14.5784 9.43782 14.4558C9.47665 14.3279 9.49607 14.1227 9.49607 13.8403C9.49607 13.5578 9.47665 13.3553 9.43782 13.2327C9.40454 13.1048 9.32964 13.0169 9.21314 12.9689C9.09664 12.9209 8.90248 12.8969 8.63064 12.8969H7.80682V14.7916H8.614Z'
                  fill='#464E5F'
                />
                <path
                  d='M11.4471 12.0176H13.1696C13.8741 12.0176 14.3734 12.0949 14.6674 12.2494C14.967 12.3986 15.1529 12.6491 15.225 13.0009C15.3027 13.3473 15.3415 13.9362 15.3415 14.7676C15.3415 15.599 15.3027 16.1905 15.225 16.5423C15.1529 16.8887 14.967 17.1392 14.6674 17.2937C14.3734 17.443 13.8741 17.5176 13.1696 17.5176H11.4471V12.0176ZM13.1197 16.6382C13.5246 16.6382 13.7965 16.6089 13.9352 16.5503C14.0794 16.4917 14.1709 16.3451 14.2098 16.1106C14.2542 15.8761 14.2763 15.4284 14.2763 14.7676C14.2763 14.1067 14.2542 13.6591 14.2098 13.4246C14.1709 13.1901 14.0794 13.0435 13.9352 12.9849C13.7965 12.9263 13.5246 12.8969 13.1197 12.8969H12.5039V16.6382H13.1197Z'
                  fill='#464E5F'
                />
                <path
                  d='M16.3879 17.5176V12.0176H19.5833V12.8969H17.4447V14.4318H19.3337V15.3192H17.4447V17.5176H16.3879Z'
                  fill='#464E5F'
                />
              </svg>
              &nbsp;
              <Text
                level={6}
                color='Text3'
                onClick={async () => {
                  try {
                    if (fileMemo1 && (fileMemo1 as any)?.originFileObj) {
                      const file = new Blob([(fileMemo1 as any)?.originFileObj], {
                        type: "application/pdf",
                      });
                      const fileURL = URL.createObjectURL(file);
                      const pdfWindow = window.open();
                      if (pdfWindow) pdfWindow.location.href = fileURL || "";
                    } else if (fileMemoUrl1) {
                      const pdfWindow = window.open();
                      if (pdfWindow) pdfWindow.location.href = fileMemoUrl1 || "";
                    }
                  } catch (error) {
                    return { error };
                  }
                }}
                style={{ cursor: fileMemo1 || fileMemoUrl1 ? "pointer" : "default" }}
              >
                {(fileMemo1 as any)?.originFileObj?.name ||
                  (fileMemoUrl1 && `${fileMemoUrl1?.substring(0, 20)}...`) ||
                  "โปรดเลือกไฟล์ .PDF"}
              </Text>
            </MemoAreaItem>
            <MemoAreaItem
              style={{
                width: 32,
                visibility:
                  (fileMemo1 as any)?.originFileObj || fileMemoUrl1 ? "visible" : "hidden",
              }}
            >
              <DeleteOutlined
                style={{ color: color.error, cursor: "pointer" }}
                onClick={() => {
                  Modal.confirm({
                    title: "ลบไฟล์ Memo ความสำเร็จ",
                    onOk: () => {
                      setFileMemo1(undefined);
                      setFileMemo(undefined);
                      if (setFileMemoUrl) setFileMemoUrl(undefined);
                    },
                  });
                }}
              />
            </MemoAreaItem>
          </MemoArea>
        </Col>
      </Row>
    </div>
  );
}

export default AchievementStep1;
